import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQueryTransactions } from "../../hooks/useQueryTransactions";
import { TalkJsContext, TalkJsContextInterface } from "../../contexts";
import { ExploreBase } from "../ExploreBase/ExploreBase";
import { Box } from "@material-ui/core";
import { StyledAvatar, ProfilePicContainer, SendMessageButton } from "./styles";
import { UserName, ButtonText, UserDetailsContainer } from "./styles";
import { ContainedButton, UserDetailsRoot, Container } from "./styles";
import { SkillsGenreContainer, styles } from "./styles";
import { useAuth0 } from "@auth0/auth0-react";
import { mapToTalkUser } from "../../utils/TalkjsUtils";
import { useGetPublicUser } from "../../hooks/useGetPublicUser";
import { emailRegex, websiteRegex } from "../../components/constants";
import { Button } from "@mui/material";
import { MusicNFT } from "../ExploreBase/types";
import { getPublishedTrack } from "../../services/trackService";
import { GetPublishedTracksResponse } from "../../proto/api_pb";
import { FractionalTransactionState } from "../../proto/api_pb";
import { GetTrackResponse } from "../../proto/api_pb";
import { RpcError } from "grpc-web";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";

export default function UserProfile(): JSX.Element {
  const [selectedState, setSelectedState] = useState("Tracks");
  const [tracks, setTracks] = useState<Array<MusicNFT>>([]);
  const { musicNFTs, isTransactionsLoading } = useQueryTransactions();
  const [sendMessageClicked, setSendMessageClicked] = useState(false);
  const username = useParams();
  const { user, isUserLoading, getUserResponse, getUserError } =
    useGetPublicUser(username["usr"]);
  const { getValidAccessToken } = useGetValidAccessToken();
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  const talkJsContext = useContext<TalkJsContextInterface>(TalkJsContext);
  const getUserNFTs = () => {
    return musicNFTs.filter((nft) =>
      nft.contributors.some(
        (contrib) => contrib.getUsername() === username["usr"]
      )
    );
  };

  const handleSendMessage = () => {
    try {
      if (talkJsContext && user) {
        if (window.innerWidth > 450) {
          talkJsContext.handleChatClick();
          talkJsContext.setParticipants([mapToTalkUser(user)]);
          setSendMessageClicked(true);
        } else {
          talkJsContext.setParticipants([mapToTalkUser(user)]);
          talkJsContext.setAutoCreateChat(true);
          navigate(`/messages`);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const extractLinks = (bio: string | undefined) => {
    if (bio) {
      const emails = bio.match(emailRegex) || [];
      const websites = bio.match(websiteRegex) || [];
      console.log(emails, websites);
      const cleanedText = bio.replace(websiteRegex, "").replace(emailRegex, "");
      return { emails, websites, cleanedText };
    }
  };

  const addProtocol = (url: string) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "https://" + url;
    } else {
      return url;
    }
  };

  const extractedLinks = extractLinks(getUserResponse?.getBio());

  const getPublishTracks = useCallback(async () => {
    try {
      if (user) {
        const accessToken = await getValidAccessToken();
        const response = await getPublishedTrack(accessToken, user);
        if (response instanceof RpcError) {
          throw response;
        }
        if (response instanceof GetPublishedTracksResponse) {
          const publishedTrack = await handleGetPublishedTracksResponse(
            response
          );
          setTracks(publishedTrack);
        }
      }
    } catch (er) {
      console.log(er);
    }
  }, [getValidAccessToken, user]);

  const handleGetPublishedTracksResponse = async (
    response: GetPublishedTracksResponse
  ) => {
    const res: GetTrackResponse[] = response.getTracksList();
    const trackNfts: any = [];
    res.forEach((el) => {
      const title = el?.getTrack()?.getTitle();
      const artist = el?.getTrack()?.getArtist();
      const description = el?.getTrack()?.getDescription();
      const image = el?.getTrack()?.getImageUrl();
      const genres = el?.getTrack()?.getSongMetadata()?.getGenre();
      const timestamp = el?.getTrack()?.getTimestamp();
      const contributors = el?.getTrack()?.getCollaboratorsList();
      const state = FractionalTransactionState.TRANSACTION_MINTED;
      const ownerId = el?.getTrack()?.getOwnerId();
      const id = el.getTrack()?.getId();
      const price = "0";
      const txnId = el?.getTrack()?.getId();
      const song = el?.getTrackVersion()?.getTrackUrl();
      trackNfts.push({
        txnId,
        id,
        title,
        artist,
        description,
        image,
        song,
        price,
        genres,
        timestamp,
        contributors,
        ownerId,
        state,
      });
    });
    return trackNfts;
  };

  useEffect(() => {
    getPublishTracks();
  }, [getValidAccessToken, getPublishTracks, user]);

  useEffect(() => {
    if (sendMessageClicked && talkJsContext) {
      talkJsContext.createConversation();
    }
  }, [talkJsContext, sendMessageClicked]);
  let skillsDiv = <div></div>;
  let genresDiv = <div></div>;
  let bioDiv = <div></div>;
  if (getUserResponse && getUserResponse?.getSkillsList().length > 0) {
    skillsDiv = (
      <UserDetailsContainer>
        <h5 style={{ marginBottom: 0, padding: "3px", fontSize: "16px" }}>
          Skills:
        </h5>
        <Box>
          <p style={{ wordBreak: "break-word" }}>
            {getUserResponse?.getSkillsList().join(", ")}
          </p>
        </Box>
      </UserDetailsContainer>
    );
  }
  if (getUserResponse && getUserResponse?.getGenresList().length > 0) {
    genresDiv = (
      <UserDetailsContainer>
        <h5 style={{ marginBottom: 0, padding: "3px", fontSize: "16px" }}>
          Genres:
        </h5>
        <Box>
          <p style={{ wordBreak: "break-word" }}>
            {getUserResponse?.getGenresList().join(", ")}
          </p>
        </Box>
      </UserDetailsContainer>
    );
  }
  if (getUserResponse && getUserResponse?.getBio().length > 0) {
    bioDiv = (
      <UserDetailsContainer>
        <Box>
          {extractedLinks?.cleanedText.split("\n").map((line, index) => (
            <p key={index} style={{ wordBreak: "break-word" }}>
              {line}
            </p>
          ))}
          {extractedLinks?.emails.map((email, index) => (
            <p key={`email-${index}`} style={styles.bioText}>
              <a href={`mailto:${email}`}>{email}</a>
            </p>
          ))}
          {extractedLinks?.websites.map((website, index) => (
            <p key={`website-${index}`} style={styles.bioText}>
              <a href={addProtocol(website)} target="_blank" rel="noreferrer">
                {website}
              </a>
            </p>
          ))}
        </Box>
      </UserDetailsContainer>
    );
  }

  const buttonContainer = (
    <Container>
      {isAuthenticated ? (
        <SendMessageButton variant="contained" onClick={handleSendMessage}>
          <ButtonText variant="subtitle1">Send Message</ButtonText>
        </SendMessageButton>
      ) : (
        <ContainedButton
          size="small"
          variant="contained"
          onClick={() =>
            loginWithRedirect({
              appState: { targetUrl: "/" },
            })
          }
        >
          Log in | Sign up
        </ContainedButton>
      )}
    </Container>
  );

  if (getUserError) {
    navigate("/not-found", { replace: true });
    return <></>;
  }

  return (
    <>
      <UserDetailsRoot>
        <ProfilePicContainer>
          <StyledAvatar
            variant={"rounded"}
            alt="profile picture"
            src={getUserResponse?.getProfilePicture()}
          />
          {user?.getUsername() && <UserName>{user?.getUsername()}</UserName>}
          {getUserResponse?.getBio() ? buttonContainer : <></>}
        </ProfilePicContainer>

        <SkillsGenreContainer>
          {skillsDiv}
          {genresDiv}
          {getUserResponse?.getBio() ? bioDiv : buttonContainer}
        </SkillsGenreContainer>
      </UserDetailsRoot>

      <div>
        <Box sx={{ display: "flex", justifyContent: "center", gridGap: "10%" }}>
          <Button
            sx={
              selectedState === "Tracks"
                ? styles.pageTitlesActive
                : styles.pageTitlesDeactive
            }
            onClick={() => setSelectedState("Tracks")}
          >
            Tracks
          </Button>
          <Button
            sx={
              selectedState === "NFT"
                ? styles.pageTitlesActive
                : styles.pageTitlesDeactive
            }
            onClick={() => setSelectedState("NFT")}
          >
            NFT
          </Button>
        </Box>
        <Box sx={{ marginTop: "30px" }}>
          {selectedState === "NFT" && (
            <Box>
              <ExploreBase
                musicNFTs={getUserNFTs()}
                isLoading={isTransactionsLoading || isUserLoading}
                userProfile
                isTrack={false}
                hideFeatured={true}
              />
            </Box>
          )}
          {selectedState === "Tracks" && (
            <Box>
              <ExploreBase
                musicNFTs={tracks}
                isLoading={isTransactionsLoading || isUserLoading}
                userProfile
                isTrack={true}
                hideFeatured={true}
              />
            </Box>
          )}
        </Box>
      </div>
    </>
  );
}
